export const password = {
  requirements:
    "Your password should be at least 8 characters and contain at least one uppercase, lowercase, and special character (!@#$%^&*()-+).",
};
